module.exports = __webpack_public_path__ + "img/mastercard.ff083076.png";